import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

export type ServiceTemplateType = 'GLOBAL' | 'CUSTOM';

/**
 * V2 model for a persisted service template, backed by the core-management
 * `/core/v3/service-templates` resource. The HATEOAS `defaultRoute` is
 * configured to `environment.v3apiUrl`, so the undecorated resource name
 * below resolves against the v3 API.
 *
 * `data` is a free-form JSON object owned by the UI — the existing
 * `ServiceTemplate` payload (config type, fields, schema, etc.) is stored
 * here. `id`, `type`, `createdBy`, `createdAt`, `updatedAt` and the
 * soft-delete fields are all server-assigned and read-only.
 */
@HateoasResource('service-templates')
export class ServiceTemplateV2 extends Resource {
    id: string;
    networkGroupId: string; // null for GLOBAL templates
    name: string;
    description?: string; // nullable
    type: ServiceTemplateType;
    data: any;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string;
    deletedBy?: string;

    // UI-only helper flag, consistent with the other V2 models
    selected = false;
}

/** POST body for creating a CUSTOM service template. */
export interface CreateServiceTemplate {
    networkGroupId: string;
    name: string;
    description?: string;
    data: any;
}

/** PUT/PATCH body for updating a CUSTOM service template. All fields optional on PATCH. */
export interface UpdateServiceTemplate {
    name?: string;
    description?: string;
    data?: any;
}
